import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TradeTypeEnum {
    public SAME_DAY = 'Same Day';
    public NEXT_DAY = 'Next Day';
    public SPOT_2_DV = 'Spot (2DV)';
    public EXTENDED_SPOT_5_DV = 'Extended Spot (5DV)';
    public FIXED_DATE_FORWARD_FDF = 'Fixed date forward (FDF)';
    public OPEN_DATE_FORWARD_ODF = 'Open date forward (ODF)';
    public SWAPS_CLOSEOUT = 'Closeout';
    public SWAPS_DRAWDOWN = 'Drawdown';
    public SWAPS_MOD_D = 'Mod-D';
    public SWAPS_ROLLOVER = 'Rollover';
    public SWAPS_MOD_R = 'Mod-R';
    public NON_DELIVERABLE_FORWARD_NDF = 'Non-deliverable forward (NDF)';
    public MARKET_ORDER = 'Market Order (Stop, Limit, OCO)';
}
